import React, { useState } from "react";
import styles from "./Auth.module.css";
import { useParams } from "react-router-dom";
import Login from "./Login";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import Verify from "./Verify";
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, Navigate } from "react-router-dom";
import NavigationBar from "../../components/navbar/NavigationBar";

function Auth() {
    const [year, setYear] = useState(new Date().getFullYear()); // Initialize with current year
    const { authentication } = useParams(); // Get the authentication type from URL
    const navigate = useNavigate();

    function renderAuthComponent() {
        switch (authentication) {
            case "login":
                return <Login />;
            case "register":
                return <Register />;
            case "forgot-password":
                return <ForgotPassword />;
            case "verify":
                return <Verify />;
            default:
                return <Navigate to="/auth/register" />;
        }
    };

    return (
        <div className={styles["authentication-container"]}>
            <div className={styles["navbar-hider"]}>
                <NavigationBar className={styles["auth-navbar"]} />
            </div>

            <div className={styles["authentication-content"]}>
                <div className={styles["auth-banner"]}>
                    <div className={styles["auth-banner-header"]}>
                        <img className={styles["logo"]} src="/assets/images/logo.webp" alt="logo" />

                        <Button
                            className={styles["btn-transparent"]}
                            href="https://smartspectra.presagetech.com"
                        >
                            <ArrowBackIcon className={styles["btn-arrow"]}/>
                            Developer Home
                        </Button>
                    </div>

                    <p className={styles["copy-right"]}>Copyright © {year} Presage Technologies</p>
                </div>

                <div className={styles["auth-form-container"]}>
                    {renderAuthComponent()}
                </div>
            </div>
        </div>
    )
}

export default Auth;
